import { Provider } from 'react-redux';
import {
  loadTranslations,
  setLocale,
  syncTranslationWithStore,
} from 'react-redux-i18n';

import { NewPedigree } from './NewPedigree';
import { createStore } from '@common/utils/redux';
import reducers from './reducers';
import { newPedigreeEN } from './translations/en';
import { newPedigreeES } from './translations/es';
import { newPedigreeJA } from './translations/ja';
import { initializeRootAndReturnRender, unmountReactNode } from '@common/utils/react';

export const initNewPedigreeWorkflow = function (locale, currentFolderId) {
  const store = createStore(reducers);

  syncTranslationWithStore(store);

  const translation = {
    en: newPedigreeEN,
    ja: newPedigreeJA,
    es: newPedigreeES,
  };

  if (!translation[locale]) {
    locale = 'en';
  }

  store.dispatch(loadTranslations(translation));
  store.dispatch(setLocale(locale));

  const container = document.createElement('div');

  document.body.appendChild(container);

  const { root, render } = initializeRootAndReturnRender(
    container
  );
  const close = () => unmountReactNode(root);

  render(
    <Provider store={store}>
      <NewPedigree close={close} currentFolderId={currentFolderId} />
    </Provider>,
  );
};
